var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-grid',{scopedSlots:_vm._u([{key:"grid",fn:function(){return [_c('DashboardEvents',{attrs:{"loading":_vm.loading}}),_c('DashboardNews',{attrs:{"loading":_vm.loading}}),_c('DashboardTrends',{attrs:{"loading":_vm.loading}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }